export default __webpack_public_path__ + "static/ELECTROSTATIC DISSIPATIVE LAMINATES-6f6d4a813883bf2804f94bb21d0aec9b.webp";